import Cookies from 'js-cookie'

const TokenKey = 'token'
const TempTokenKey = 'temptoken'
const IosScheme = 'ios_scheme'

export function getToken() {
  return Cookies.get(TokenKey)
}
export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 7 })
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}


export function getTempToken() {
  return Cookies.get(TempTokenKey)
}
export function setTempToken(token) {
  return Cookies.set(TempTokenKey, token, { expires: 7 })
}
export function removeTempToken() {
  return Cookies.remove(TempTokenKey)
}




// WEBPACK FOOTER //
// ./src/utils/auth.js